export const errorIplan = [
  {
    firstCode: "000000",
    secondCode: "00000000",
    messsage: "Complete Success"
  },
  {
    firstCode: "000001",
    secondCode: "00000000",
    messsage: "Successful, within lateness tolerance"
  },
  {
    firstCode: "000010",
    secondCode: "00000000",
    messsage: "Successful, outside lateness tolerance"
  },
  {
    firstCode: "000011",
    secondCode: "00000000",
    messsage: "Successful, booked outside planning horizon"
  },
  {
    firstCode: "100011",
    secondCode: "00000000",
    messsage: "Failure, no capacity available on PMs"
  },
  {
    firstCode: "100100",
    secondCode: "00000000",
    messsage: "Failure, no capacity available on FLs"
  },
  {
    firstCode: "100101",
    secondCode: "00000000",
    messsage: "Failure, no finishing line run available"
  },
  {
    firstCode: "100101",
    secondCode: "00000001",
    messsage: "Failure, no finishing line run available"
  },
  {
    firstCode: "100110",
    secondCode: "00000000",
    messsage: "Failure, no PM run available"
  },
  {
    firstCode: "100111",
    secondCode: "00000001",
    messsage: "Failure, no sources found"
  },
  {
    firstCode: "100111",
    secondCode: "00000010",
    messsage: "Failure, no sources found"
  },
  {
    firstCode: "100111",
    secondCode: "00000001",
    messsage: "Failure, no sources found"
  },
  {
    firstCode: "101000",
    secondCode: "10000001",
    messsage: "Failure, invalid location code"
  },
  {
    firstCode: "101000",
    secondCode: "00000001",
    messsage: "Failure, invalid location code"
  },
  {
    firstCode: "101000",
    secondCode: "10000010",
    messsage: "Failure, invalid location code"
  },
  {
    firstCode: "101001",
    secondCode: "10000001",
    messsage: "Failure, invalid product code"
  },
  {
    firstCode: "101001",
    secondCode: "00000001",
    messsage: "Failure, invalid product code"
  },
  {
    firstCode: "101010",
    secondCode: "10000001",
    messsage: "Failure, invalid SKU"
  },
  {
    firstCode: "101011",
    secondCode: "00000000",
    messsage: "Failure, parameter invalid or not specified"
  },
  {
    firstCode: "101011",
    secondCode: "10000000",
    messsage: "Failure, parameter invalid or not specified"
  },
  {
    firstCode: "101011",
    secondCode: "00000001",
    messsage: "Failure, parameter invalid or not specified Quantity"
  },
  {
    firstCode: "101011",
    secondCode: "10000001",
    messsage: "Failure, parameter invalid or not specified Quantity"
  },
  {
    firstCode: "101011",
    secondCode: "00000010",
    messsage: "Failure, parameter invalid or not specified InquiryMethodCode"
  },
  {
    firstCode: "101011",
    secondCode: "10000010",
    messsage: "Failure, parameter invalid or not specified InquiryMethodCode"
  },
  {
    firstCode: "101011",
    secondCode: "10000011",
    messsage: "Failure, parameter invalid or not specified FixSourceAssignment"
  },
  {
    firstCode: "101011",
    secondCode: "00000100",
    messsage: "Failure, parameter invalid or not specified SFGProductCode"
  },
  {
    firstCode: "101011",
    secondCode: "10000100",
    messsage: "Failure, parameter invalid or not specified SFGProductCode"
  },
  {
    firstCode: "101011",
    secondCode: "00000101",
    messsage: "Failure, parameter invalid or not specified TransportMethodName"
  },
  {
    firstCode: "101011",
    secondCode: "10000101",
    messsage: "Failure, parameter invalid or not specified TransportMethodName"
  },
  {
    firstCode: "101011",
    secondCode: "00000110",
    messsage: "Failure, parameter invalid or not specified LateDays"
  },
  {
    firstCode: "101011",
    secondCode: "10000110",
    messsage: "Failure, parameter invalid or not specified LateDays"
  },
  {
    firstCode: "101011",
    secondCode: "00000111",
    messsage: "Failure, parameter invalid or not specified TypeOfDelivery"
  },
  {
    firstCode: "101011",
    secondCode: "10000111",
    messsage: "Failure, parameter invalid or not specified TypeOfDelivery"
  },
  {
    firstCode: "101011",
    secondCode: "00001000",
    messsage:
      "Failure, parameter invalid or not specified CheckAllocationMethod"
  },
  {
    firstCode: "101011",
    secondCode: "10001000",
    messsage:
      "Failure, parameter invalid or not specified CheckAllocationMethod"
  },
  {
    firstCode: "101011",
    secondCode: "00001001",
    messsage: "Failure, parameter invalid or not specified TransportAreaCode"
  },
  {
    firstCode: "101011",
    secondCode: "10001001",
    messsage: "Failure, parameter invalid or not specified TransportAreaCode"
  },
  {
    firstCode: "101011",
    secondCode: "00001010",
    messsage: "Failure, parameter invalid or not specified OrderSplit"
  },
  {
    firstCode: "101011",
    secondCode: "10001010",
    messsage: "Failure, parameter invalid or not specified OrderSplit"
  },
  {
    firstCode: "101011",
    secondCode: "00001011",
    messsage: "Failure, parameter invalid or not specified SingleSourcing"
  },
  {
    firstCode: "101011",
    secondCode: "10001011",
    messsage: "Failure, parameter invalid or not specified SingleSourcing"
  },
  {
    firstCode: "101011",
    secondCode: "00001100",
    messsage: "Failure, parameter invalid or not specified FinishingLock"
  },
  {
    firstCode: "101011",
    secondCode: "10001100",
    messsage: "Failure, parameter invalid or not specified FinishingLock"
  },
  {
    firstCode: "101011",
    secondCode: "00001101",
    messsage: "Failure, parameter invalid or not specified UseOpportunisticRuns"
  },
  {
    firstCode: "101011",
    secondCode: "10001101",
    messsage: "Failure, parameter invalid or not specified UseOpportunisticRuns"
  },
  {
    firstCode: "101011",
    secondCode: "00001110",
    messsage: "Failure, parameter invalid or not specified PartialDelivery"
  },
  {
    firstCode: "101011",
    secondCode: "10001110",
    messsage: "Failure, parameter invalid or not specified PartialDelivery"
  },
  {
    firstCode: "101011",
    secondCode: "00001111",
    messsage: "Failure, parameter invalid or not specified DisregardAllocation"
  },
  {
    firstCode: "101011",
    secondCode: "10001111",
    messsage: "Failure, parameter invalid or not specified DisregardAllocation"
  },
  {
    firstCode: "101011",
    secondCode: "00010000",
    messsage: "Failure, parameter invalid or not specified RequestType"
  },
  {
    firstCode: "101011",
    secondCode: "10010000",
    messsage: "Failure, parameter invalid or not specified RequestType"
  },
  {
    firstCode: "101011",
    secondCode: "00010001",
    messsage: "Failure, parameter invalid or not specified LoggingLevel"
  },
  {
    firstCode: "101011",
    secondCode: "10010001",
    messsage: "Failure, parameter invalid or not specified LoggingLevel"
  },
  {
    firstCode: "101011",
    secondCode: "00010010",
    messsage: "Failure, parameter invalid or not specified Quality"
  },
  {
    firstCode: "101011",
    secondCode: "10010010",
    messsage: "Failure, parameter invalid or not specified Quality"
  },
  {
    firstCode: "101011",
    secondCode: "00010011",
    messsage: "Failure, parameter invalid or not specified RequestDate"
  },
  {
    firstCode: "101011",
    secondCode: "10010011",
    messsage: "Failure, parameter invalid or not specified RequestDate"
  },
  {
    firstCode: "101011",
    secondCode: "00010100",
    messsage: "Failure, parameter invalid or not specified StartNotBefore"
  },
  {
    firstCode: "101011",
    secondCode: "10010100",
    messsage: "Failure, parameter invalid or not specified StartNotBefore"
  },
  {
    firstCode: "101011",
    secondCode: "00010101",
    messsage: "Failure, parameter invalid or not specified SourceTypes "
  },
  {
    firstCode: "101011",
    secondCode: "10010101",
    messsage: "Failure, parameter invalid or not specified SourceTypes "
  },
  {
    firstCode: "101100",
    secondCode: "00000000",
    messsage: "Failure, new inquiry submitted but Order already exists"
  },
  {
    firstCode: "101101",
    secondCode: "00000000",
    messsage: "Failure, order does not exist, requote"
  },
  {
    firstCode: "101101",
    secondCode: "00000001",
    messsage: "Failure, order does not exist, resend"
  },
  {
    firstCode: "101101",
    secondCode: "00000010",
    messsage: "Failure, order does not exist, delete"
  },
  {
    firstCode: "101111",
    secondCode: "00000000",
    messsage: "Failure, new inquiry submitted but RequestCode already exists"
  },
  {
    firstCode: "110000",
    secondCode: "00000000",
    messsage: "Failure, requote submitted but LineCode is not 0"
  },
  {
    firstCode: "110001",
    secondCode: "00000001",
    messsage: "Failure, order can not be deleted"
  },
  {
    firstCode: "110001",
    secondCode: "00000010",
    messsage: "Failure, order can not be deleted"
  },
  {
    firstCode: "110001",
    secondCode: "00000011",
    messsage: "Failure, order can not be deleted"
  },
  {
    firstCode: "110010",
    secondCode: "00000000",
    messsage: "No available source with transport route"
  },
  {
    firstCode: "110011",
    secondCode: "00000000",
    messsage:
      "Failure, insufficient quantity of specified SFG Material available"
  },
  {
    firstCode: "110100",
    secondCode: "00000000",
    messsage: "Failure, due to BS planning lock"
  },
  {
    firstCode: "110110",
    secondCode: "00000000",
    messsage: ""
  },
  {
    firstCode: "110111",
    secondCode: "00000000",
    messsage: "Failure, Rollback timeout has expired"
  },
  {
    firstCode: "110111",
    secondCode: "Failure, Not found some of the orders necessary for rollback",
    messsage:
      "Failure, Not found some of the orders necessary for amendment acceptance"
  },
  {
    firstCode: "110111",
    secondCode: "00000001",
    messsage: ""
  },
  {
    firstCode: "111110",
    secondCode: "00000000",
    messsage: "Failure, error in program initiation"
  },
  {
    firstCode: "111111",
    secondCode: "00000000",
    messsage: "Failure, Unexpected error"
  }
];
export const mapCodeToMessageIplant = (
  firstCode: string,
  secondCode: string,
  messageOptional: string
) => {
  const error = errorIplan.find(
    item => item.firstCode === firstCode && item.secondCode === secondCode
  );
  return error ? error.messsage : messageOptional || "";
};
